import React from 'react';
import '../App.css';
import cfl from '../config.json';
import $ from 'jquery';
import config from '.././config.json';
import moment from 'moment';
import DatePickerDropdown from '.././Registration/DatePickerDropdown';
import { Redirect } from 'react-router';
import LoginForm from '../LoginForm.js';
import usStates from '../usStates';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import {
    Button, Spin, notification, Row, Col
} from 'antd';

const shortFormItemLayout = {
    labelCol: {
        xs: { span: 24, pull: 22 },
        sm: { span: 6, pull: 0 },
    },
    wrapperCol: {
        xs: { span: 4 },
        sm: { span: 3 },
    },
};

const midFormItemLayout = {
    labelCol: {
        xs: { span: 24, pull: 22 },
        sm: { span: 6, pull: 0 },
    },
    wrapperCol: {
        xs: { span: 12 },
        sm: { span: 8 },
    },
};

class DeleteStudentForm extends React.Component {
    formVariables = [{ FirstName: '' }, { MiddleInitial: '' }, { LastName: '' }, { DLN: '' }, { DateofBirth: '' }, { StreetAddress: '' }, { State: '' }, { City: '' },
    { ZipCode: '' }, { PhoneNumber: '' }, { Email: '' }, { TechID: '' }];

    constructor(props) {
        super(props);

        this.state = {
            currentEmployer: "",
            loading: false,
            login: true,
        };
        var enrollmentFlag = false;

    }

    setEmployer(emplID) {
        let company = "";
        $.ajax({
            type: 'POST',
            url: `${config.serverUrl}/api/registration/getallemployer`,
        })
            .done((data) => {
                for (let i = 0; i < data.length; i++) {
                    if (data[i].Id === emplID) {
                        let employer = data[i];
                        company = employer.CompanyName + ", " + employer.City + " (" + employer.State + ")";
                        this.setState({ currentEmployer: company });
                        break;
                    }
                }
            })
            .fail((jqXhr) => {
                console.log('failed to get employer');
            });
    }

    checkEnrolled() {
        //console.log("StudentID:" + this.props.ID);
        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/students/CheckStudentEnrollment/`,
            data: { ID: this.props.ID }
        })
            .done((data) => {
                //console.log("Checking Enrollment");
                //console.log(data);
                if (data == -1) { this.enrollmentFlag = false; }
                else { this.enrollmentFlag = true; }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                console.log('failed to get data');
            });
    }

    componentDidMount() {
        this.setState({ loading: true });

        LoginForm.ValidateServerToken(
            () => { this.setState({ login: false }) }, //logout
            () => {
                if (typeof this.props.updateFields !== 'undefined') {
                    this.setEmployer(this.props.empData.Id);
                }

                this.setState({ loading: false });
            }); //login
        this.checkEnrolled();
    }

    /**
    * submit event
    * @param {any} e synthetic event
    */
    handleSubmit = (e) => {
        //Format the data to be recieved by the server
        if (this.enrollmentFlag == false) {
            var formObj = {}
            formObj.Id = this.props.updateFields.Id;
            this.setState({ loading: true })
            this.ajaxCall('POST', '/api/students/delete',
                formObj, (data) => {//success
                    this.setState({ loading: false })
                    this.props.updateEvent();
                }, () => {//fail
                    this.openNotificationWithIcon('error', 'Failed To Delete', 'Connection to server may have been lost!')
                    this.setState({ loading: false })
                    console.log('failed to delete');
                });
        } else { window.alert("Cannot delete a student who is currently enrolled in a class."); }
    }

    /**
     * Used for custom ajax calls
     * @param {any} type type of HTTP request
     * @param {any} url url of controller
     * @param {any} data data of entry being deleted
     * @param {any} done function executed on success
     * @param {any} fail function executed on failure
     */
    ajaxCall(type, url, data, done, fail) {
        $.ajax({
            type: type,
            url: `${config.serverUrl}` + url,
            data: data
        })
            .done((data) => {
                done(data);
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                fail();
            });
    }

    /**
    * Opens the Notification window
    * @param {any} type type of notification
    * @param {any} title message title
    * @param {any} body message body
    */
    openNotificationWithIcon = (type, title, body) => {
        notification[type]({
            message: title,
            description: body,
        });
    };

    /**
     * Render Function
     * @returns {any} page render
     */
    render() {

        const formItemLayout = {
            labelCol: {
                xs: { span: 24, pull: 22 },
                sm: { span: 6, pull: 0 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 14 },
            },
        };
        const tailFormItemLayout = {
            xs: {
                offset: 0,
            },
            sm: {
                offset: 6,
            },
        };

        return (
            <div>
                {this.state.login ?
                    <Spin spinning={this.state.loading}>
                        <h2>Edit Student</h2>
                        <hr />

                        <div className='forms'>
                            {/*------------------------------------------ User Details ------------------------------------------*/}
                            <Row>
                                <Col {...formItemLayout.labelCol}><p className='boldRight'>First Name</p></Col>
                                <Col {...formItemLayout.wrapperCol}>{':  ' + this.props.updateFields.FirstName}</Col>
                            </Row><br />
                            <Row>
                                <Col {...shortFormItemLayout.labelCol}><p className='boldRight'>Middle Initial</p> </Col>
                                <Col {...shortFormItemLayout.wrapperCol}>{':  ' + this.props.updateFields.MiddleInitial}</Col>
                            </Row><br />
                            <Row>
                                <Col {...formItemLayout.labelCol}><p className='boldRight'>Last Name</p></Col>
                                <Col {...formItemLayout.wrapperCol}>{':  ' + this.props.updateFields.LastName}</Col>
                            </Row><br />
                            <Row>
                                <Col {...formItemLayout.labelCol}><p className='boldRight'>Tech ID</p></Col>
                                <Col {...formItemLayout.wrapperCol}>{':  ' + this.props.updateFields.TechID}</Col>
                            </Row><br />
                            <Row>
                                <Col {...formItemLayout.labelCol}><p className='boldRight'>Date of Birth</p></Col>
                                <Col {...formItemLayout.wrapperCol}>{':  ' + this.props.date}</Col>
                            </Row><br />

                            {/*------------------------------------------ ADDRESS ------------------------------------------*/}
                            <Row>
                                <Col {...formItemLayout.labelCol}><p className='boldRight'>Street</p></Col>
                                <Col {...formItemLayout.wrapperCol}>{':  ' + this.props.updateFields.StreetAddress}</Col>
                            </Row><br />
                            <Row>
                                <Col {...formItemLayout.labelCol}><p className='boldRight'>City</p></Col>
                                <Col {...formItemLayout.wrapperCol}>{':  ' + this.props.updateFields.City}</Col>
                            </Row><br />
                            <Row>
                                <Col {...formItemLayout.labelCol}><p className='boldRight'>State</p></Col>
                                <Col {...formItemLayout.wrapperCol}>{':  ' + this.props.updateFields.State}</Col>
                            </Row><br />
                            <Row>
                                <Col {...midFormItemLayout.labelCol}><p className='boldRight'>ZipCode</p></Col>
                                <Col {...midFormItemLayout.wrapperCol}>{':  ' + this.props.updateFields.ZipCode}</Col>
                            </Row><br />

                            {/*------------------------------------------ CONTACT ------------------------------------------*/}
                            <Row>
                                <Col {...formItemLayout.labelCol}><p className='boldRight'>Phone Number</p></Col>
                                <Col {...formItemLayout.wrapperCol}>{':  ' + this.props.updateFields.PhoneNumber}</Col>
                            </Row><br />
                            <Row>


                                <Col {...formItemLayout.labelCol}><p className='boldRight'>E-mail</p></Col>
                                <Col {...formItemLayout.wrapperCol}>{':  ' + this.props.updateFields.Email}</Col>
                            </Row><br />
                            <Row>
                                <Col {...formItemLayout.labelCol}><p className='boldRight'>Employer</p></Col>
                                <Col {...formItemLayout.wrapperCol}>{':  ' + this.state.currentEmployer}</Col>
                            </Row><br />
                            <Row>
                                <Col {...tailFormItemLayout}>
                                    <button type="submit" className="btn btn-default" onClick={() => { this.props.updateEvent(); }}>Cancel</button>
                                    <button type="submit" className="btn btn-default" onClick={() => { if (window.confirm('Are you sure you wish to delete this item?')) this.handleSubmit() }} style={{ margin: 5 }}>Delete</button>
                                </Col>
                            </Row>
                        </div>
                    </Spin>
                    : <Redirect to="/login" replace />
                }
            </div>
        );
    }

}

export default DeleteStudentForm;


// WEBPACK FOOTER //
// ./src/Admin/DeleteStudentForm.js